// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Contact_ContactDesktop__q5ruw {
  width: 60px;
  background-color: #70E072;
  transition: width 0.5s ease-in-out;
  cursor: pointer;
}
.Contact_ContactDesktop__q5ruw .Contact_content__dvZJd {
  padding: 110px 121px 66px;
  width: calc(50vw - 180px);
}
.Contact_ContactDesktop__q5ruw .Contact_content__dvZJd .Contact_title__kF8u\\+ {
  font-family: "Poppins", sans-serif;
  font-size: 48px;
  line-height: 100%;
  color: #140C0F;
  font-weight: 700;
  padding-bottom: 30px;
}
.Contact_ContactDesktop__q5ruw .Contact_content__dvZJd .Contact_text__dU3QD {
  font-family: "Inter", sans-serif;
  font-size: 20px;
  line-height: 150%;
  color: #140C0F;
  margin-bottom: 64px;
}
.Contact_ContactDesktop__q5ruw .Contact_content__dvZJd .Contact_messageTitle__O3CM\\+ {
  margin-bottom: 22px;
  font-family: "Poppins", sans-serif;
  font-size: 22px;
  line-height: 80%;
  color: #140C0F;
}
.Contact_ContactDesktop__q5ruw .Contact_content__dvZJd form {
  width: 80%;
  display: flex;
  flex-direction: column;
}
.Contact_ContactDesktop__q5ruw .Contact_content__dvZJd form label {
  font-family: "Inter", sans-serif;
  font-size: 13px;
  line-height: 150%;
  color: #140C0F;
}
.Contact_ContactDesktop__q5ruw .Contact_content__dvZJd form input, .Contact_ContactDesktop__q5ruw .Contact_content__dvZJd form textarea {
  font-family: "Inter", sans-serif;
  font-size: 18px;
  line-height: 150%;
  color: #140C0F;
  background-color: transparent;
  border: none;
  outline: none;
  text-decoration: none;
  border-bottom: 1px solid #140C0F;
  padding-bottom: 2px;
  margin-bottom: 27px;
}
.Contact_ContactDesktop__q5ruw .Contact_content__dvZJd .Contact_buttons__Nvoy1 {
  display: flex;
  justify-content: start;
  gap: 13px;
}
.Contact_ContactDesktop__q5ruw .Contact_content__dvZJd .Contact_buttons__Nvoy1 .Contact_approve__Os\\+8i, .Contact_ContactDesktop__q5ruw .Contact_content__dvZJd .Contact_buttons__Nvoy1 .Contact_clear__gAQ5N {
  display: flex;
  width: 132px;
  padding: 12px 23px;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  border-radius: 800px;
  border: 1px solid #140C0F;
  cursor: pointer;
}
.Contact_ContactDesktop__q5ruw .Contact_content__dvZJd .Contact_buttons__Nvoy1 .Contact_approve__Os\\+8i {
  background: #140C0F;
  color: #fff;
}
.Contact_ContactDesktop__q5ruw .Contact_content__dvZJd .Contact_buttons__Nvoy1 .Contact_clear__gAQ5N, .Contact_ContactDesktop__q5ruw .Contact_content__dvZJd .Contact_buttons__Nvoy1 .Contact_sent__cY2xU {
  color: #140C0F;
  background-color: transparent;
}
.Contact_ContactDesktop__q5ruw .Contact_content__dvZJd .Contact_buttons__Nvoy1 .Contact_sent__cY2xU {
  cursor: default;
}
.Contact_ContactDesktop__q5ruw .Contact_content__dvZJd .Contact_success__IAY9D {
  display: flex;
  flex-direction: row;
  gap: 14px;
  background-color: #A5F2A6;
  margin-top: 52px;
  padding: 15px 37px 16px 20px;
  width: 80%;
  font-family: "Inter", sans-serif;
  font-size: 16px;
  line-height: 150%;
  color: #140C0F;
}
.Contact_ContactDesktop__q5ruw .Contact_content__dvZJd .Contact_copyright__wqslI {
  margin-top: 80px;
}

.Contact_selectedDesktop__1JjjF {
  cursor: default;
  width: calc(50vw - 180px);
}

.Contact_ContactTablet__xKRnm {
  width: 100vw;
  background-color: #70E072;
  cursor: pointer;
}
.Contact_ContactTablet__xKRnm .Contact_closeIcon__o1MaY {
  position: fixed;
  right: 30px;
  top: 28px;
  z-index: 2;
}
.Contact_ContactTablet__xKRnm .Contact_content__dvZJd {
  padding: 112px 24px 30px 24px;
}
.Contact_ContactTablet__xKRnm .Contact_content__dvZJd .Contact_title__kF8u\\+ {
  font-family: "Poppins", sans-serif;
  font-size: 48px;
  line-height: 100%;
  color: #140C0F;
  font-weight: 700;
  padding-bottom: 30px;
}
.Contact_ContactTablet__xKRnm .Contact_content__dvZJd .Contact_text__dU3QD {
  font-family: "Inter", sans-serif;
  font-size: 20px;
  line-height: 150%;
  color: #140C0F;
  margin-bottom: 44px;
}
.Contact_ContactTablet__xKRnm .Contact_content__dvZJd .Contact_links__QBm4t {
  display: flex;
  gap: 30px;
  margin-bottom: 50px;
}
.Contact_ContactTablet__xKRnm .Contact_content__dvZJd .Contact_links__QBm4t svg {
  height: 46px;
  width: 46px;
}
.Contact_ContactTablet__xKRnm .Contact_content__dvZJd .Contact_messageTitle__O3CM\\+ {
  margin-top: 20px;
  margin-bottom: 22px;
  font-family: "Poppins", sans-serif;
  font-size: 22px;
  line-height: 80%;
  color: #140C0F;
}
.Contact_ContactTablet__xKRnm .Contact_content__dvZJd form {
  display: flex;
  flex-direction: column;
}
.Contact_ContactTablet__xKRnm .Contact_content__dvZJd form label {
  font-family: "Inter", sans-serif;
  font-size: 13px;
  line-height: 150%;
  color: #140C0F;
}
.Contact_ContactTablet__xKRnm .Contact_content__dvZJd form input, .Contact_ContactTablet__xKRnm .Contact_content__dvZJd form textarea {
  font-family: "Inter", sans-serif;
  font-size: 18px;
  line-height: 150%;
  color: #140C0F;
  background-color: transparent;
  border: none;
  outline: none;
  text-decoration: none;
  border-bottom: 1px solid #140C0F;
  padding-bottom: 2px;
  margin-bottom: 27px;
  width: 85vw;
}
.Contact_ContactTablet__xKRnm .Contact_content__dvZJd .Contact_buttons__Nvoy1 {
  display: flex;
  justify-content: start;
  gap: 13px;
}
.Contact_ContactTablet__xKRnm .Contact_content__dvZJd .Contact_buttons__Nvoy1 .Contact_approve__Os\\+8i, .Contact_ContactTablet__xKRnm .Contact_content__dvZJd .Contact_buttons__Nvoy1 .Contact_clear__gAQ5N {
  display: flex;
  width: 132px;
  padding: 12px 23px;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  border-radius: 800px;
  border: 1px solid #140C0F;
  cursor: pointer;
}
.Contact_ContactTablet__xKRnm .Contact_content__dvZJd .Contact_buttons__Nvoy1 .Contact_approve__Os\\+8i {
  background: #140C0F;
  color: #fff;
}
.Contact_ContactTablet__xKRnm .Contact_content__dvZJd .Contact_buttons__Nvoy1 .Contact_clear__gAQ5N, .Contact_ContactTablet__xKRnm .Contact_content__dvZJd .Contact_buttons__Nvoy1 .Contact_sent__cY2xU {
  color: #140C0F;
  background-color: transparent;
}
.Contact_ContactTablet__xKRnm .Contact_content__dvZJd .Contact_buttons__Nvoy1 .Contact_sent__cY2xU {
  cursor: default;
}
.Contact_ContactTablet__xKRnm .Contact_content__dvZJd .Contact_success__IAY9D {
  display: flex;
  flex-direction: row;
  gap: 14px;
  background-color: #A5F2A6;
  margin-top: 52px;
  padding: 15px 37px 16px 20px;
  font-family: "Inter", sans-serif;
  font-size: 16px;
  line-height: 150%;
  color: #140C0F;
}
.Contact_ContactTablet__xKRnm .Contact_content__dvZJd .Contact_copyright__wqslI {
  margin-top: 64px;
}

.Contact_selectedTablet__M1k3l {
  cursor: default;
  position: absolute;
  top: 0;
  left: 0;
  height: 100vh;
  width: 100vw;
}`, "",{"version":3,"sources":["webpack://./src/tabs/Contact/Contact.module.scss","webpack://./src/styles/variables.scss"],"names":[],"mappings":"AAEA;EACE,WCFU;EDGV,yBCSQ;EDRR,kCC+Be;ED9Bf,eAAA;AADF;AAGE;EACE,yBAAA;EACA,yBAAA;AADJ;AAGI;ECoIF,kCAtGkB;EAuGlB,eA1Fa;EA2Fb,iBAtFe;EAuFf,cA7IgB;EA8IhB,gBAvGW;ED/BP,oBAAA;AAGN;AAAI;ECmFF,gCA3DiB;EA4DjB,eAlDa;EAmDb,iBA3Ce;EA4Cf,cAjGgB;EDaZ,mBAAA;AAKN;AAFI;EACE,mBAAA;EC4FJ,kCAzEkB;EA0ElB,eAhEa;EAiEb,gBAxDc;EAyDd,cAhHgB;ADyBlB;AAJI;EACE,UAAA;EACA,aAAA;EACA,sBAAA;AAMN;AAJM;ECwCJ,gCA/BiB;EAgCjB,eA1Ba;EA2Bb,iBAfe;EAgBf,cArEgB;ADoClB;AANM;ECyDJ,gCApDiB;EAqDjB,eA5Ca;EA6Cb,iBApCe;EAqCf,cA1FgB;EDgCV,6BAAA;EACA,YAAA;EACA,aAAA;EACA,qBAAA;EACA,gCAAA;EACA,mBAAA;EACA,mBAAA;AAWR;AANI;EACE,aAAA;EACA,sBAAA;EACA,SAAA;AAQN;AANM;EACE,aAAA;EACA,YAAA;EACA,kBAAA;EACA,sBAAA;EACA,uBAAA;EACA,mBAAA;EACA,oBAAA;EACA,yBAAA;EACA,eAAA;AAQR;AALM;EACE,mBAAA;EACA,WAAA;AAOR;AAJM;EACE,cClEU;EDmEV,6BAAA;AAMR;AAHM;EACE,eAAA;AAKR;AADI;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,yBCvEQ;EDwER,gBAAA;EACA,4BAAA;EACA,UAAA;ECFJ,gCA7CiB;EA8CjB,eAtCa;EAuCb,iBA7Be;EA8Bf,cAnFgB;ADyFlB;AAHI;EACE,gBAAA;AAKN;;AAEA;EACE,eAAA;EACA,yBAAA;AACF;;AAEA;EACE,YAAA;EACA,yBC9FQ;ED+FR,eAAA;AACF;AACE;ECjFA,eAAA;EACA,WAAA;EACA,SAAA;EACA,UAAA;ADmFF;AADE;EACE,6BClGwB;ADqG5B;AADI;EC2BF,kCAtGkB;EAuGlB,eA1Fa;EA2Fb,iBAtFe;EAuFf,cA7IgB;EA8IhB,gBAvGW;ED0EP,oBAAA;AAON;AAJI;ECtBF,gCA3DiB;EA4DjB,eAlDa;EAmDb,iBA3Ce;EA4Cf,cAjGgB;EDsHZ,mBAAA;AASN;AANI;EACE,aAAA;EACA,SAAA;EACA,mBAAA;AAQN;AAPM;EACE,YAAA;EACA,WAAA;AASR;AAJI;EACE,gBAAA;EACA,mBAAA;ECzBJ,kCAzEkB;EA0ElB,eAhEa;EAiEb,gBAxDc;EAyDd,cAhHgB;ADgJlB;AANI;EACE,aAAA;EACA,sBAAA;AAQN;AANM;EC5EJ,gCA/BiB;EAgCjB,eA1Ba;EA2Bb,iBAfe;EAgBf,cArEgB;AD0JlB;AARM;EC3DJ,gCApDiB;EAqDjB,eA5Ca;EA6Cb,iBApCe;EAqCf,cA1FgB;EDoJV,6BAAA;EACA,YAAA;EACA,aAAA;EACA,qBAAA;EACA,gCAAA;EACA,mBAAA;EACA,mBAAA;EACA,WAAA;AAaR;AATI;EACE,aAAA;EACA,sBAAA;EACA,SAAA;AAWN;AATM;EACE,aAAA;EACA,YAAA;EACA,kBAAA;EACA,sBAAA;EACA,uBAAA;EACA,mBAAA;EACA,oBAAA;EACA,yBAAA;EACA,eAAA;AAWR;AARM;EACE,mBAAA;EACA,WAAA;AAUR;AAPM;EACE,cCtLU;EDuLV,6BAAA;AASR;AANM;EACE,eAAA;AAQR;AAJI;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,yBC3LQ;ED4LR,gBAAA;EACA,4BAAA;ECrHJ,gCA7CiB;EA8CjB,eAtCa;EAuCb,iBA7Be;EA8Bf,cAnFgB;AD+MlB;AANI;EACE,gBAAA;AAQN;;AAHA;EChME,eAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;EACA,aAAA;EACA,YAAA;ADuMF","sourcesContent":["@import \"src/styles/variables\";\n\n.ContactDesktop {\n  width: $tab-width;\n  background-color: $Contact;\n  transition: $tab-transition;\n  cursor: pointer;\n\n  .content {\n    padding: 110px 121px 66px;\n    width: calc(100vw - 50vw - 180px);\n\n    .title {\n      @include font-title-48;\n      padding-bottom: 30px;\n    }\n\n    .text {\n      @include font-20;\n      margin-bottom: 64px;\n    }\n\n    .messageTitle {\n      margin-bottom: 22px;\n      @include font-22\n    }\n\n    form {\n      width: 80%;\n      display: flex;\n      flex-direction: column;\n\n      label {\n        @include font-13;\n      }\n\n      input, textarea {\n        @include font-18;\n        background-color: transparent;\n        border: none;\n        outline: none;\n        text-decoration: none;\n        border-bottom: 1px solid $sub-title-color;\n        padding-bottom: 2px;\n        margin-bottom: 27px;\n        //width: 1px;\n      }\n    }\n\n    .buttons {\n      display: flex;\n      justify-content: start;\n      gap: 13px;\n\n      .approve, .clear {\n        display: flex;\n        width: 132px;\n        padding: 12px 23px;\n        flex-direction: column;\n        justify-content: center;\n        align-items: center;\n        border-radius: 800px;\n        border: 1px solid $sub-title-color;\n        cursor: pointer;\n      }\n\n      .approve {\n        background: #140C0F;\n        color: #fff;\n      }\n\n      .clear, .sent {\n        color: $sub-title-color;\n        background-color: transparent;\n      }\n\n      .sent {\n        cursor: default;\n      }\n    }\n\n    .success {\n      display: flex;\n      flex-direction: row;\n      gap: 14px;\n      background-color: $MessageSent;\n      margin-top: 52px;\n      padding: 15px 37px 16px 20px;\n      width: 80%;\n      @include font-16;\n    }\n\n    .copyright {\n      margin-top: 80px;\n      //position: absolute;\n      //bottom: 60px;\n    }\n  }\n}\n\n.selectedDesktop {\n  cursor: default;\n  width: calc(50vw - #{$not-active-tabs-width});\n}\n\n.ContactTablet {\n  width: 100vw;\n  background-color: $Contact;\n  cursor: pointer;\n\n  .closeIcon {\n    @include closeIcon;\n  }\n\n  .content {\n    padding: $mobile-tab-tablet-padding;\n\n    .title {\n      @include font-title-48;\n      padding-bottom: 30px;\n    }\n\n    .text {\n      @include font-20;\n      margin-bottom: 44px;\n    }\n\n    .links {\n      display: flex;\n      gap: 30px;\n      margin-bottom: 50px;\n      svg {\n        height: 46px;\n        width: 46px;\n        //fill: $Contact;\n      }\n    }\n\n    .messageTitle {\n      margin-top: 20px;\n      margin-bottom: 22px;\n      @include font-22;\n    }\n\n    form {\n      display: flex;\n      flex-direction: column;\n\n      label {\n        @include font-13;\n      }\n\n      input, textarea {\n        @include font-18;\n        background-color: transparent;\n        border: none;\n        outline: none;\n        text-decoration: none;\n        border-bottom: 1px solid $sub-title-color;\n        padding-bottom: 2px;\n        margin-bottom: 27px;\n        width: 85vw;\n      }\n    }\n\n    .buttons {\n      display: flex;\n      justify-content: start;\n      gap: 13px;\n\n      .approve, .clear {\n        display: flex;\n        width: 132px;\n        padding: 12px 23px;\n        flex-direction: column;\n        justify-content: center;\n        align-items: center;\n        border-radius: 800px;\n        border: 1px solid $sub-title-color;\n        cursor: pointer;\n      }\n\n      .approve {\n        background: #140C0F;\n        color: #fff;\n      }\n\n      .clear, .sent {\n        color: $sub-title-color;\n        background-color: transparent;\n      }\n\n      .sent {\n        cursor: default;\n      }\n    }\n\n    .success {\n      display: flex;\n      flex-direction: row;\n      gap: 14px;\n      background-color: $MessageSent;\n      margin-top: 52px;\n      padding: 15px 37px 16px 20px;\n      @include font-16;\n    }\n\n    .copyright {\n      margin-top: 64px;\n    }\n  }\n}\n\n.selectedTablet {\n  @include selectedTablet;\n}\n","//tab sizes\n$tab-width: 60px;\n$not-active-tabs-width: 180px;\n\n//fonts colors\n$title-color: #191114;\n$sub-title-color: #140C0F;\n$footer-color: #323433;\n\n//tabs colors\n$aboutUs: #0085FF;\n$Business: #69B4FF;\n$News: #E0FFFF;\n$Contact: #70E072;\n$MessageSent: #A5F2A6;\n\n//def padding\n$mobile-tab-tablet-padding: 112px 24px 30px 24px;\n\n//def tab content styles\n@mixin selectedTablet {\n  cursor: default;\n  position: absolute;\n  top: 0;\n  left: 0;\n  height: 100vh;\n  width: 100vw;\n}\n@mixin closeIcon {\n  position: fixed;\n  right: 30px;\n  top: 28px;\n  z-index: 2;\n}\n\n//transitions\n$tab-transition: width .5s ease-in-out;\n$left-content-transition-1: opacity .7s ease-in-out;\n$left-content-transition-2: opacity 3s ease-in-out;\n\n//fonts values\n$font-family-main: 'Inter', sans-serif;\n$font-family-title: 'Poppins', sans-serif;\n\n$font-w-400: 400;\n$font-w-700: 700;\n\n$font-size-13: 13px;\n$font-size-14: 14px;\n$font-size-16: 16px; //150%\n$font-size-18: 18px; //150%\n$font-size-20: 20px; // 150%\n$font-size-22: 22px;\n$font-size-24: 24px; //150%\n$font-size-32: 32px; //100%\n$font-size-48: 48px; //80%\n\n$font-size-179: 179px; //80%\n\n$font-line-150p: 150%;\n$font-line-100p: 100%;\n$font-line-80p: 80%;\n\n//font variants\n@mixin font-title-179 {\n  font-family: $font-family-title;\n  font-size: $font-size-179;\n  line-height: $font-line-80p;\n  font-weight: $font-w-700;\n}\n\n@mixin font-13 {\n  font-family: $font-family-main;\n  font-size: $font-size-13;\n  line-height: $font-line-150p;\n  color: $sub-title-color;\n}\n\n@mixin font-14 {\n  font-family: $font-family-main;\n  font-size: $font-size-14;\n  line-height: 16px;\n  color: $sub-title-color;\n}\n\n@mixin font-16 {\n  font-family: $font-family-main;\n  font-size: $font-size-16;\n  line-height: $font-line-150p;\n  color: $sub-title-color;\n}\n\n@mixin font-18 {\n  font-family: $font-family-main;\n  font-size: $font-size-18;\n  line-height: $font-line-150p;\n  color: $sub-title-color;\n}\n\n@mixin font-20 {\n  font-family: $font-family-main;\n  font-size: $font-size-20;\n  line-height: $font-line-150p;\n  color: $sub-title-color;\n}\n\n@mixin font-20-title {\n  font-family: $font-family-title;\n  font-size: $font-size-20;\n  line-height: $font-line-100p;\n  color: $sub-title-color;\n  font-weight: $font-w-700;\n}\n\n@mixin font-22 {\n  font-family: $font-family-title;\n  font-size: $font-size-22;\n  line-height: $font-line-80p;\n  color: $sub-title-color;\n}\n\n@mixin font-24 {\n  font-family: $font-family-main;\n  font-size: $font-size-24;\n  line-height: $font-line-150p;\n  color: $title-color;\n  font-weight: $font-w-400;\n}\n\n@mixin font-24-bold {\n  @include font-24;\n  color: $sub-title-color;\n  font-weight: $font-w-700;\n}\n\n@mixin font-title-32 {\n  font-family: $font-family-title;\n  font-size: $font-size-32;\n  line-height: $font-line-100p;\n  color: $sub-title-color;\n  font-weight: $font-w-700;\n}\n\n@mixin font-title-48 {\n  font-family: $font-family-title;\n  font-size: $font-size-48;\n  line-height: $font-line-100p;\n  color: $sub-title-color;\n  font-weight: $font-w-700;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"ContactDesktop": `Contact_ContactDesktop__q5ruw`,
	"content": `Contact_content__dvZJd`,
	"title": `Contact_title__kF8u+`,
	"text": `Contact_text__dU3QD`,
	"messageTitle": `Contact_messageTitle__O3CM+`,
	"buttons": `Contact_buttons__Nvoy1`,
	"approve": `Contact_approve__Os+8i`,
	"clear": `Contact_clear__gAQ5N`,
	"sent": `Contact_sent__cY2xU`,
	"success": `Contact_success__IAY9D`,
	"copyright": `Contact_copyright__wqslI`,
	"selectedDesktop": `Contact_selectedDesktop__1JjjF`,
	"ContactTablet": `Contact_ContactTablet__xKRnm`,
	"closeIcon": `Contact_closeIcon__o1MaY`,
	"links": `Contact_links__QBm4t`,
	"selectedTablet": `Contact_selectedTablet__M1k3l`
};
export default ___CSS_LOADER_EXPORT___;
